<div
  #buttonContainer
  class="w-full">
  @if (!showMenu) {
    <div
      class="flex gap-2 flex-wrap w-full"
      [ngClass]="{'flex-row-reverse': align === 'right', 'flex-reverse': align === 'left', 'flex-col': isStacked}">
      @for (button of buttons; track button) {
        <hmax-button
          #hmaxButton
          [button]="button"
        (buttonClick)="onClick($event)"></hmax-button>
      }
    </div>
  }

  @if (showMenu) {
    <!-- Icon Button -->
    <button
      mat-stroked-button
      aria-label="lista de botões"
      [matMenuTriggerFor]="buttonMenu">
      <mat-icon class="icon-size-5">menu</mat-icon>
    </button>
    <mat-menu #buttonMenu="matMenu">
      @for (button of buttons; track button) {
        <button
          mat-menu-item
          [disabled]="button?.disabled"
          (click)="onClick(button?.label ?? '')">
          @if (button?.icon) {
            <mat-icon
              class="icon-size-5 p-0 m-0 pr-2"
            [svgIcon]="button.icon ?? ''"></mat-icon>
          }
          <ng-container *transloco="let t">
            {{ t(button?.label ?? '') | capitalize }}
          </ng-container>
        </button>
      }
    </mat-menu>
  }
</div>
